import { computed } from 'vue';

import { useUserStore } from '~/stores/use-user.store';
import { ERROR_NOT_FOUND } from '~/services/RequestService';

export const useInit = () => {
  const { $viewport } = useNuxtApp();

  const userStore = useUserStore();

  const isBrowser = computed((): boolean => {
    return import.meta.client;
  });

  const isYandexBrowser = computed((): boolean => {
    const userAgent =
      typeof navigator !== 'undefined' && navigator.userAgent ? navigator.userAgent : '';
    return /YaBrowser\//i.test(userAgent);
  });

  const isDesktop = computed((): boolean => {
    return $viewport?.isGreaterOrEquals('desktop') ?? true;
  });

  const isTabletMore = computed((): boolean => {
    return $viewport?.isGreaterOrEquals('tablet') ?? false;
  });

  const isTablet = computed((): boolean => {
    return $viewport?.isLessThan('desktop') ?? false;
  });

  const isMobile = computed((): boolean => {
    return $viewport?.isLessThan('tablet') ?? false;
  });

  const isMobileMediumLess = computed((): boolean => {
    return $viewport?.isLessThan('mobileMedium') ?? false;
  });

  const isUserAuthenticated = computed((): boolean => {
    return userStore.isAccessUser;
  });

  const isUserLoaded = computed((): boolean => {
    return !!userStore.isUserLoaded;
  });

  async function isProtected() {
    console.log(isUserAuthenticated.value);

    if (!isUserAuthenticated.value) {
      await navigateTo('/');
      throw createError({
        statusCode: ERROR_NOT_FOUND.HTTP_CODE,
        statusMessage: ERROR_NOT_FOUND.MESSAGE,
      });
    }
  }

  return {
    isBrowser,
    isYandexBrowser,
    isDesktop,
    isTablet,
    isTabletMore,
    isMobile,
    isMobileMediumLess,
    isUserAuthenticated,
    isUserLoaded,
    isProtected,
  };
};
